import React from 'react';

import JobsListSubPage from '../../../js/pages/JobsListPage/SubPage';
import dataEngineer from '../../../js/pages/JobsListPage/dataEngineerJobs';
import {makeStaticPaths, makeStaticProps} from '../../../js/pages/JobsListPage/staticRoutes';

const Page = ({slug}) => <JobsListSubPage role={dataEngineer} slug={slug} />;

export default Page;

export const getStaticProps = makeStaticProps(dataEngineer);
export const getStaticPaths = makeStaticPaths(dataEngineer);
